// this is a replacement for launchDarkly flags
export default function useFlags() {
  return {
    permGroupFeedRanking: false,
    permGroups: true,
    permPrivateGroups: false,
    permEvents: true,
    permMaintenanceMembershipText: {
      title: "You are currently subscribed to our maintenance membership",
      defaultMessage:
        "To unlock access to all community benefits contact concierge to restore your membership at the legacy price point.",
      successMessage:
        "Keep an eye on your inbox for next steps to restore your membership. Our concierge team will be in touch shortly.",
    },
    permMediaToolkit: true,
    permExpertPanels: true,
    permPublishing: true,
    permReferMemberCopy: {
      confirmation: [
        "Thank you for your referral!",
        "Please allow us 2-4 business days to review your submission and determine membership eligibility.",
        "We will keep you informed of our decision. Please check your email for the next steps.",
      ],
    },
    permDailyDigest: true,
    permPolls: true,
    permContentStudio: false,
    permGroupsHeaderCopy:
      "Let's connect on things we have in common! Join a Group to share what you know, get inspired, meet new people, and stay informed.",
    permMemberLeaderApplication: true,
    permMediaToolkitSections: ["announce", "social", "support"],
    permPremiumMembershipText: "",
    permMaintenanceMembershipEntitlements: [
      "Exec perks",
      "Settings",
      "Profile",
      "Manage Profile",
      "Refer members",
    ],
  };
}
